import React, { useState } from "react";
import { toast } from "react-toastify";

interface TextCopyProps {
  text: string;
  showText?: boolean;
  showIcon?: boolean;
  maxWidth?: string;
  iconClass?: string;
  successIconClass?: string;
  iconSize?: string;
}

const TextCopy: React.FC<TextCopyProps> = ({
  text,
  showText = true,
  showIcon = true,
  maxWidth = "180px",
  iconClass = "ti ti-copy",
  successIconClass = "ti ti-check",
  iconSize = "14px",
}) => {
  const [copied, setCopied] = useState<boolean>(false);

  if (!text) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    toast.success("Copied successfully");

    setTimeout(() => setCopied(false), 900);
  };

  return (
    <div
      className="d-flex align-items-center gap-2"
      style={{ cursor: "pointer", maxWidth }}
      onClick={handleCopy}
      title="Click to copy"
    >
      {showText && (
        <p
          className="text-muted small mb-0"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            margin: 0,
          }}
        >
          {text}
        </p>
      )}

      {showIcon && (
        <i
          className={copied ? successIconClass : iconClass}
          style={{
            fontSize: iconSize,
            color: copied ? "green" : "#6c757d",
            transition: "0.3s ease",
          }}
        />
      )}
    </div>
  );
};

export default TextCopy;
